import { useState, type FormEvent } from "react";
import { ApiError } from "../lib/api";
import { useAuth } from "../lib/auth";

export function LoginPage() {
  const { signIn } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      await signIn(username, password);
    } catch (cause) {
      setError(
        cause instanceof ApiError ? cause.message : "Sign in failed. Try again.",
      );
      setIsSubmitting(false);
    }
  }

  return (
    <main className="signin">
      <div className="signin__card">
        <header className="signin__mark">
          <h1 className="signin__title">Image desk</h1>
        </header>
        <p className="signin__lede">
          Sign in to file images to Cloudreve and read back their links.
        </p>

        <form className="signin__form" onSubmit={handleSubmit}>
          {error && (
            <div className="notice" role="alert">
              {error}
            </div>
          )}

          <div className="field">
            <label className="label" htmlFor="username">
              Username
            </label>
            <input
              id="username"
              type="text"
              autoComplete="username"
              autoFocus
              required
              value={username}
              onChange={(event) => setUsername(event.target.value)}
            />
          </div>

          <div className="field">
            <label className="label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>

          <button className="btn btn--primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Signing in" : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
